import React from "react";
import {
  Create,
  Edit,
  TextInput,
  SelectInput,
  email,
  required
} from "admin-on-rest";
import IconTitle from "../components/icon_title";
import OlaForm from "../components/form/OlaForm";

const UserForm = props => (
  <OlaForm {...props}>
    <TextInput
      label="resources.users.fieldList.first_name"
      source="first_name"
    />
    <TextInput
      label="resources.users.fieldList.last_name"
      source="last_name"
      validate={required}
    />
    <TextInput
      label="resources.users.fieldList.google_email"
      source="email"
      validate={[required, email]}
    />
    <TextInput
      label="resources.users.fieldList.mobile"
      source="mobile"
      validate={required}
    />
    <SelectInput
      label="resources.users.fieldList.role.title"
      source="role"
      choices={[
        {
          id: "Partner Admin",
          name: "resources.users.fieldList.role.choices.partner_admin"
        },
        {
          id: "Partner User",
          name: "resources.users.fieldList.role.choices.partner_user"
        },
        {
          id: "Recruiter",
          name: "resources.users.fieldList.role.choices.recruiter"
        }
      ]}
    />
  </OlaForm>
);

export const UserCreate = props => (
  <Create
    {...props}
    title={<IconTitle icon="accounts" title={"resources.users.title"} />}
  >
    <UserForm {...props} />
  </Create>
);

export const UserEdit = props => (
  <Edit
    {...props}
    title={<IconTitle icon="accounts" title={"resources.users.title"} />}
  >
    <UserForm {...props} />
  </Edit>
);



// WEBPACK FOOTER //
// ./src/users/Create.js